/* ------------------------------ */
/* Add Readmore and substring text   */
/* ------------------------------ */

window.textSubstr = function textSubstr() {
    var custom_breakpoint,
        jsTextSubstr = $('.jsTextSubstr');

    if (jsTextSubstr.length > 0) {
        jsTextSubstr.each(function() {
            if ($(this).length && $(this).data('custom-breakpoint')) {
                custom_breakpoint = $(this).data('custom-breakpoint');
            } else {
                custom_breakpoint = window.breakpoints.tabletPortrait;
            }

            if (windowWidth <= custom_breakpoint && $(this).closest('.textWrap').find('.readMore').length === 0 && $(this).length) {

                var $jsTextSubstr = $(this),
                    subStringText,
                    orginalText,
                    subStringLength;

                if ($jsTextSubstr.data('length') !== '') {
                    subStringLength = parseInt($jsTextSubstr.data('length'));
                } else {
                    subStringLength = 200;
                }

                if ($jsTextSubstr.data('custom-length') && windowWidth >= window.breakpoints.mobile) {
                    subStringLength = parseInt($jsTextSubstr.data('custom-length'))
                }

                subStringText = $jsTextSubstr.html().substring(0, subStringLength);
                orginalText = $jsTextSubstr.html();

                $jsTextSubstr.data('original', orginalText);
                $jsTextSubstr.data('sub', subStringText);

                if (subStringLength < $jsTextSubstr.text().length) {
                    $jsTextSubstr.html($jsTextSubstr.data('sub'));
                    $jsTextSubstr.children().last().append('...');
                    $jsTextSubstr.parent().append("<a href='#' class='readMore'> Read More +</a>");
                }
            } else if (windowWidth > custom_breakpoint && $(this).length) {
                $(this).parent().find('.readMore').remove();
                $(this).html($(this).data('original'));
            }
        });
    }
}

$(document).ready(function () {
    'use strict';

    if ($('.jsTextSubstr').length) {
        textSubstr();
    }

    $('body').on('click', '.readMore', function (e) {
        killclick(e);

        var $this = $(this),
            $jsTextSubstr = $(this).closest('.textWrap').find('.jsTextSubstr');

        if ($jsTextSubstr.html() === $jsTextSubstr.data('original')) {
            $jsTextSubstr.html($jsTextSubstr.data('sub'));
            $jsTextSubstr.children().last().append('...');
            $this.text('Read More +');
            $this.removeClass('readLess');
        } else {
            $jsTextSubstr.html($jsTextSubstr.data('original'));
            $this.text('Read Less -');
            $this.addClass('readLess');
        }
    });
});

$(window).on('resize', debouncer(function (e) {
    'use strict';

    textSubstr();
}));
